import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const ReviewArticle = () => {
  const navigate = useNavigate();
  const [articles, setArticles] = useState([]);

  const fetchArticles = async () => {
    try {
      const response = await fetch("https://backend.impactjournal.co.in/manuscript/alldetailsmanu");
      if (!response.ok) throw new Error("Failed to fetch articles");
      const data = await response.json();
      setArticles(data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchArticles();
  }, []);

  // Group articles by volume and remove duplicate issues
  const groupedByVolume = articles.reduce((acc, article) => {
    if (!acc[article.volume]) acc[article.volume] = {};
    // use issue_id as key to avoid duplicates
    if (!acc[article.volume][article.issue_id]) {
      acc[article.volume][article.issue_id] = article;
    }
    return acc;
  }, {});


  // Sort volumes numerically before rendering
  const sortedVolumes = Object.entries(groupedByVolume).sort((a, b) => {
    // Extract numbers from volume names like "Volume1", "Volume2"
    const numA = parseInt(a[0].replace(/\D/g, ""), 10);
    const numB = parseInt(b[0].replace(/\D/g, ""), 10);
    return numA - numB; // ascending order
  });


  return (
    <div className="review-article-container">
      {sortedVolumes.map(([volumeName, issuesObj]) => (
        <div key={volumeName}>
          {/* Volume heading with year */}
          <div className="review-article-header">
            <h2 className="review-article-title">{volumeName}</h2>
            <span className="review-article-year">
              {issuesObj && Object.values(issuesObj)[0]
                ? new Date(Object.values(issuesObj)[0].createdAt).getFullYear()
                : ""}
            </span>
          </div>

          <hr className="review-article-divider" />

          <div className="review-article-list">
            {Object.values(issuesObj).map((article) => {
              const createdDate = new Date(article.createdAt);
              const monthYear = createdDate.toLocaleString("default", { month: "long", year: "numeric" }); // e.g., December-2025

              return <div
                key={article.id}
                onClick={() => navigate(`/issues/${article.volume_id}/${article.issue_id}`)}
                className="review-article-item"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <h3 className="review-article-item-title">{article.issue}</h3>
                {/* <span className="review-article-item-date">
                  {monthYear}
                </span> */}
              </div>
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReviewArticle;


// <div className="review-article-container">
//   {/* Heading + Date row */}
//   <div className="review-article-header">
//     <h2 className="review-article-title">Review Articles</h2>
//     <span className="review-article-year">2025</span>
//   </div>

//   {/* Horizontal line */}
//   <hr className="review-article-divider" />

//   {/* Issue list */}
//   <div className="review-article-list">
//     {articles.map((article, index) => (
//       <div
//         key={index}
//         onClick={() => navigate(article.path)}
//         className="review-article-item"
//       >
//         <h3 className="review-article-item-title">{article.title}</h3>
//         <span className="review-article-item-date">{article.date}</span>
//       </div>
//     ))}
//   </div>
// </div>